module.exports = __webpack_public_path__ + "img/big-map-mobile.d54d697.svg";